import axios from "axios";
import { keycloakInterceptor } from "../auth/keycloakService";
import { IEntidade, IPessoaJuridica, IPlanoBeneficio } from "../Interfaces/DadosPrevicInterfaces";
import { hasText } from "../utils/utilsFunctions";


const apiCad = axios.create({
  baseURL: process.env.REACT_APP_URL_API_CAD,
});
apiCad.interceptors.request.use(keycloakInterceptor);


export const getEntidadePorCnpj = async(cnpj :string) =>{
  try {
    const { data } = await apiCad.get<IEntidade>(`/efpc/por-numero-pj/${cnpj}/numero`);
    return data;
  } catch (error: any) {
    return undefined;
  }  
}
export const getEntidadePorMatricula = async(matricula :string) =>{
  try {
    const { data } = await apiCad.get<IEntidade>(`/efpc/ultimo/${matricula}/numero`);
    return data;
  } catch (error: any) {
    return undefined;
  }  
}
export const getTodasEntidades = async() =>{
  const{ data } = await apiCad.get(`/efpc/consulta/dinamica`);
  //const res:IEntidade[] = data.content;
  const res:IEntidade[] = data;
  return res;
}

export const getPessoaJuridica = async (cnpj :string) => {
  return apiCad.get<IPessoaJuridica>(`/pessoa-juridica/ultimo/${cnpj}/numero`);
}

export const postPessoaJuridica = async (cnpj :string) => {
  await apiCad.post(`/pessoa-juridica/inserir-por-cnpj`, {
    numero: cnpj
  });
  return getPessoaJuridica(cnpj);
}

export const pesquisarPessoasJuridicas = async (cnpj :string|undefined, razaoSocial :string, linhasPorPagina :number|undefined, page :number|undefined) => {
    let lQuery;
    if (hasText(cnpj)){
      try {
        const { data } = await getPessoaJuridica(cnpj!);
        return [data];
      } catch (error) {
        return [];
      }
    } else {
      if (!razaoSocial) return [];
      const params = new URLSearchParams({
        "razao-social": razaoSocial,
      });
      if (linhasPorPagina) params.set('limit', linhasPorPagina.toString());
      if (page) params.set('page', page.toString());

      lQuery = `/pessoa-juridica/consulta/dinamica?${params.toString()}`;
    }
    const { data } = await apiCad.get(lQuery);
    const res:IPessoaJuridica[] = data.content;
    return res;
}
export const pesquisarPlanosBeneficios = async (matriculaEfpc :string, linhasPorPagina :number|undefined, page :number|undefined) => {
    const params = new URLSearchParams();
    if (linhasPorPagina) params.set('limit', linhasPorPagina.toString());
    if (page) params.set('page', page.toString());

    let lQuery = `plano-de-beneficios/ultimo/${matriculaEfpc}/matricula?${params.toString()}`;
    const { data } = await apiCad.get<IPlanoBeneficio[]>(lQuery);
    return data;
}
